import axios from "axios";
const API_BASE_URL = "https://fishbot-backend.herokuapp.com/";

export const posidonHighscoresApi = axios.create({
  baseURL: API_BASE_URL + "api/bossbattlehs/posidon",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
